export default "__VITE_ASSET__YovGd9R4__"